export const environment = {
  production: false,
  apiProjectUrl: "https://a314-projects-dev.drh.avwaveinteractive.com/projects",
  apiUrlAdmin:
    "https://a314-admin-users-dev.drh.avwaveinteractive.com/admin-users",
  apiGoogleStorage:
    "https://a314-google-storage-dev.drh.avwaveinteractive.com/storage",
  urlStorage: "https://storage.googleapis.com/drh-avwave-dev/",
  testUser: {
    // tslint:disable-line
    token: "cualquiercosa",
    email: "user@user.user",
  },
};
